import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { Text, tokens } from '../design-system';

const T = {
  paper:     '#F7EFD8',
  paperDeep: '#EEE2BF',
  card:      '#FFFBEC',
  ink:       '#2E2109',
  inkMuted:  '#6E5A38',
  inkFaint:  '#A39068',
  rule:      '#D7C9A1',
  orange:    '#EA7C1F',
  moss:      '#6B7A3E',
  capRed:    '#C14A33',
  r3: '10px', r4: '14px',
  sh1: '0 1px 0 rgba(46,33,9,0.06), 0 2px 4px rgba(46,33,9,0.04)',
  sans: '"Nunito", ui-sans-serif, system-ui, -apple-system, sans-serif',
};

/**
 * ProtectedRoute component that redirects to login page if user is not authenticated
 */
const ProtectedRoute = ({ children }) => {
  const { isAuthenticated, loading } = useAuth();
  const location = useLocation();

  // Show loading spinner while checking authentication status
  if (loading) {
    return (
      <div style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '100vh',
        flexDirection: 'column',
        gap: tokens.spacing[4],
        backgroundColor: T.paper,
        fontFamily: T.sans,
      }}>
        <div style={{
          width: '48px',
          height: '48px',
          border: `4px solid ${T.rule}`,
          borderTop: `4px solid ${T.orange}`,
          borderRadius: tokens.borderRadius.full,
          animation: 'spin 1s linear infinite',
        }} />
        <Text style={{ color: T.inkMuted, fontFamily: T.sans }}>
          Checking authentication...
        </Text>
      </div>
    );
  }

  // Redirect to login if not authenticated
  const authenticated = isAuthenticated();

  if (!authenticated) {
    // Not authenticated, redirecting to login
    // Save the current location to redirect back after login
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  // Render children if authenticated
  return children;
};

export default ProtectedRoute;
